import { Action, ActionFn, defaultActions } from '#/common/components/DataGrid';
import { Alert } from '#/graphql/types';

export const selectedActions: ActionFn<Alert>[] = [
  {
    key: 'ignore',
    icon: 'ban',
    text: 'Ignore Exception',
  },
  {
    key: 'create-work-order',
    icon: 'wrench-simple',
    text: 'Create Work Order',
  },
  {
    key: 'create-finding',
    icon: 'flag',
    text: 'Create Finding',
  },
];

export const actions: Action<Alert>[] = [...defaultActions];
